module.exports = __webpack_public_path__ + "549942a1504c2857ea61b934b323e17e.svg";